import { NavLink } from 'react-router';
import './HomeInfo.css';

export default function HomeInfo(){
    return(
        <div className='the-content'>
            <h1 className='the-heading'>Haulage Services across the UK</h1>
            <p>Anywhere you are, we can help.</p>
            <h1 className='the-heading'>Solutions built on trust and communication</h1>
            <p>Whether you are a supplier, manufacturer, distributor, or logistics provider, we understand the importance of keeping supply chains moving efficiently and on time.</p>
            <h2>All of our drivers are DBS-Checked for your peace of mind.</h2>
            <h1 className='the-heading'>Quality Services</h1>
            <p>Our team of qualified drivers and expert fleet are ready to help you accomplish your goals.</p>
            <p>To find out more about our fleet, click <NavLink to="/about" onClick={() => window.scrollTo(0, 0)}>here.</NavLink></p>
        </div>
    )
}